import request from '@/assets/js/request';

/**
 * 查询歌曲的函数
 * @param {string} trackName - 歌曲名称
 * @param {number} pageNo - 页码，默认值为 1
 * @param {number} pageSize - 每页显示的歌曲数，默认值为 50
 * @return {Promise} - 一个 Promise，如果请求成功，它将 resolve 歌曲列表数据
 */
export function querySongs(trackName, pageNo = 1, pageSize = 50) {
    return request({
        url: '/cpSplitRule/trackPage',
        method: 'GET',
        params: {trackName, pageNo, pageSize},
        formData: false,
    });
}

/**
 * 根据专辑 ID 和曲目 ID 获取分成信息
 * @param {number} albumId - 专辑的唯一标识符
 * @param {number} trackId - 曲目的唯一标识符
 * @return {Promise} - 一个 Promise，当初始请求成功并返回数据时解析为一个对象，否则解析为错误
 */
export function getInfo(trackId, albumId) {
    return request({
        url: '/cpSplitRule/trackCpSplitInfo',
        method: 'GET',
        params: {albumId, trackId},
        formData: false,
    });
}

/**
 * 发起的分账歌曲列表
 * @param {number} pageNo - 页码，默认为 1
 * @param {number} pageSize - 每页显示的行数，默认为 20
 * @return {Promise} 一个 Promise，当初始请求成功并返回数据时解析为一个对象，否则解析为错误
 */
export function fetchInitiatedList(pageNo = 1, pageSize = 20) {
    return request({
        url: '/cpSplitRule/selfSplitTrackPage',
        method: 'GET',
        params: {pageNo, pageSize},
        formData: false,
    });
}

/**
 * 收到的分账列表
 * @param {number} pageNo - 页码，默认为 1
 * @param {number} pageSize - 每页显示的行数，默认为 20
 * @return {Promise} 一个 Promise，当初始请求成功并返回数据时解析为一个对象，否则解析为错误
 */
export function fetchReceiveList(pageNo = 1, pageSize = 20) {
    return request({
        url: '/cpSplitRule/splitToCpTrackPage',
        method: 'GET',
        params: {pageNo, pageSize},
        formData: false,
    });
}

/**
 * 确认歌曲数量的函数
 * @return {Promise} - 一个 Promise，当初始请求成功并返回数据时解析为一个对象，否则解析为错误
 */
export function confirmSongsNum() {
    return request({
        url: '/cpSplitRule/splitToCpWaitConfirmNum',
        method: 'GET',
        formData: false,
    });
}

/**
 * 新增歌曲规则
 * @return {Promise} - 一个 Promise，当初始请求成功并返回数据时解析为一个对象，否则解析为错误
 */
export function addSongsRule(formData) {
    return request({
        url: '/cpSplitRule/addTrackRule',
        method: 'POST',
        data: formData,
        formData: false,
    });
}

/**
 * 分账歌曲信息确认
 * @param {number} albumId - 专辑的唯一标识符
 * @param {number} trackId - 曲目的唯一标识符
 * @return {Promise} - 一个 Promise，当初始请求成功并返回数据时解析为一个对象，否则解析为错误
 */
export function confirmSongs(albumId, trackId) {
    return request({
        url: '/cpSplitRule/splitToCpConfirm',
        method: 'GET',
        data: {albumId, trackId},
        formData: false,
    });
}

/**
 * 分账规则-合同获取
 * @param {string} albumId - 专辑的唯一标识符
 * @param {string} trackId - 歌曲的唯一标识符
 * @returns {Promise} - 包含歌曲规则信息的 Promise 对象
 */
export function getSongsRuleContract(ruleId) {
    return request({
        url: '/letSign/viewCpSplitContract',
        method: 'GET',
        params: {ruleId},
    });
}

/**
 * 分账规则-合同签署
 * @param {string} albumId - 专辑的唯一标识符
 * @param {string} trackId - 歌曲的唯一标识符
 * @returns {Promise} - 包含歌曲规则信息的 Promise 对象
 */
export function signSongsRuleContract(contractCode, serialNumber, verificationCode, cpSplitRuleId) {
    return request({
        url: '/letSign/cpSplitSign',
        method: 'POST',
        data: {contractCode, serialNumber, verificationCode, cpSplitRuleId},
        formData: false,
    });
}

/**
 * 查询分成规则结果
 * @param {*} ruleId
 * @returns
 */
export function getSplitResults(ruleId) {
    return request({
        url: '/cpSplitRule/ruleInfo',
        method: 'GET',
        params: {ruleId},
        formData: false,
    });
}

/**
 * 分账规则-合同获取 - 法大大
 * @param {string} albumId - 专辑的唯一标识符
 * @param {string} trackId - 歌曲的唯一标识符
 * @returns {Promise} - 包含歌曲规则信息的 Promise 对象
 */
export function getSongsRuleFddContract(ruleId) {
    return request({
        url: 'fabigbig/viewCpSplitContract',
        method: 'GET',
        params: {ruleId},
        formData: false,
    });
}

/**
 * 分账规则-合同签署 - 法大大
 * @param {string} albumId - 专辑的唯一标识符
 * @param {string} trackId - 歌曲的唯一标识符
 * @returns {Promise} - 包含歌曲规则信息的 Promise 对象
 */
export function signSongsRuleFddContract(contractCode, cpSplitRuleId) {
    return request({
        url: '/fabigbig/cpSplitSign',
        method: 'POST',
        data: {contractCode, cpSplitRuleId},
        formData: false,
    });
}
/**
 * 取消分成
 * @param {*} formData 
 */
export function cpSplitRuleCancel(formData) {
    return request({
        url: '/cpSplitRule/splitCancel',
        method: 'POST',
        headers: {'Content-Type': 'multipart/form-data'},
        data: formData,
        formData: false
    });
}
/**
 * 停止分成
 * @param {*} formData 
 * @returns 
 */
export function cpSplitRuleStop(formData) {
    return request({
        url: '/cpSplitRule/splitStop',
        method: 'POST',
        headers: {'Content-Type': 'multipart/form-data'},
        data: formData,
        formData: false
    });
}